import { useContext } from 'react';
import ArtworkIcon from "src/assets/all-icons/artwork-icon.jsx";

import ArtworkDataContext from '@/context/ArtworkDataContext';
import useStateHandler from '@/hooks/useStateHandler';
import UserService from '@/services/user.service';
import ArtlistImage from '@/shared-components/cards/components/ArtlistImage';
import Text from '@/shared-components/text/components/Text';

import './styles/ArtlistItem.css';

export default function ArtlistItem({ artlistData, close }) {
  const { stateHandler, cacheHandler } = useStateHandler();
  const { artworkData } = useContext(ArtworkDataContext);

  function addArtworkToArtlist() {
    UserService.addArtworkToArtlist(artworkData, artlistData._id);
    cacheHandler.triggerAction("ADD_TO_ARTLIST_FROM_ARTWORK");
    stateHandler.set("temporalPopup", {
      text: (
        <>
          <em>{artworkData.artwork_about.artwork_title}</em> added to your Artlist: <em>{artlistData.artlist_title}</em>
        </>
      ), 
      type: "navbar-present"
    });
    close();
  }

  return (
    <>
      <div className="add-to-artlist-artlist-item__container" onClick={addArtworkToArtlist}>
        <ArtlistImage className="add-to-artlist-artlist-item__image" image={artlistData.artlist_image?.image_id}/>

        <Text className="add-to-artlist-artlist-item__title dots-on-overflow" medium paragraph>
          {artlistData.artlist_title}
        </Text>

        <Text className="add-to-artlist-artlist-item__count" small>
          {artlistData.artlist_artworks.length}
        </Text>

        <ArtworkIcon className="add-to-artlist-artlist-item__count-icon"/>
      </div>
    </>
  );
}
